import { TagTypes } from "../../../Api/Types/tagTypes";
import { BankAccount } from "../Types/bankAccountTypes";
import { bankAccountsApi } from "./bankAccountsApi";

const extendedBankAccountsApi = bankAccountsApi.injectEndpoints({
	endpoints: (builder) => ({
		getBankAccountsForCompany: builder.query<BankAccount[], number>({
			query: (companyId) => `bank-account/company/${companyId}`,
			providesTags: (result, error, companyId) => {
				const tags = result
					? [
							...result.map((item) => ({
								type: TagTypes.BankAccount,
								id: item.id,
							})),
							{ type: TagTypes.BankAccount, id: `COMPANY_${companyId}` },
					  ]
					: [{ type: TagTypes.BankAccount, id: `COMPANY_${companyId}` }];
				return tags;
			},
		}),
	}),
});

export const { useGetBankAccountsForCompanyQuery } = extendedBankAccountsApi;
